import { sortBy } from 'lodash';

export default {
  getCategoryCodes: (state) => {
    const result = state.categoryCodes.map((c) => {
      let text = `${c.code} - ${c.name}`;
      const parent = state.categoryCodes.find((p) => p.code === c.parentCode)?.name;
      if (parent) {
        text += ` - ${parent}`;
      }
      return {
        text,
        code: c.code,
      };
    });
    return sortBy(result, (c) => c.text);
  },
  getCategoryTypes: () => [
    'Above-the-Line',
    'Below-the-Line Production',
    'VFX Production',
    'Below-the-Line Post Production',
    'General Expenses Production',
  ],
};
